import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TView } from '@shared/types/view';
import type { TBaseQuery } from '@shared/types/base-query';

export type TViewQuery = {
  entity_id?: number;
  entity_type?: TView['entity_type'];
  is_default?: boolean;
  is_public?: boolean;
} & TBaseQuery;

type CreateViewPayload = {
  visible_fields?: number[];
  filters?: number[];
  custom_filters?: number[];

  entity_type?: TView['entity_type'];
  entity_id?: number;

  name?: string;
  description?: string;

  is_default?: boolean;
  is_public?: boolean;

  visible_static_fields?: TView['visible_static_fields'];
  static_filters?: TView['static_filters'];
};

const viewApi = createCrudService<TView, TViewQuery, CreateViewPayload>({
  queryKey: [QUERY_KEYS.getViews],
  url: 'views',
});

export default viewApi;
